/**
 * @file useActions
 * @author yucenhao
 */

import {bindActionCreators} from 'redux';
import {useDispatch} from 'react-redux';
import {useMemo, DependencyList} from 'react';

const useActions = (actions: any, deps?: DependencyList[]) => {
    const dispatch = useDispatch();

    return useMemo(() => {
        if (Array.isArray(actions)) {
            return actions.map(a => bindActionCreators(a, dispatch));
        }
        return bindActionCreators(actions, dispatch);
    }, deps ? [dispatch, ...deps] : [dispatch]);
};

export default useActions;
